// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"171":"09cefb1e","312":"91c58ae6","324":"0be9a3df","383":"7b14e4b0","726":"f7f759a9"}[chunkId] + ".js";
};